import { render, staticRenderFns } from "./ChooseOnboardingProcess.vue?vue&type=template&id=754d8d26&scoped=true"
import script from "./ChooseOnboardingProcess.vue?vue&type=script&lang=js"
export * from "./ChooseOnboardingProcess.vue?vue&type=script&lang=js"
import style0 from "./ChooseOnboardingProcess.vue?vue&type=style&index=0&id=754d8d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d8d26",
  null
  
)

export default component.exports